import axios from 'axios'

const config = {
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_ROOT_API : '/v3/'
}

export default {
  FileUpload(data) {
    return axios.post(`${config.baseURL}upload/file`, data)
  },
  RequestProject(data) {
    return axios.post(`${config.baseURL}request`, data)
  }
}